module.exports = __webpack_public_path__ + "static/media/taunt.75aca66f.png";